import { Autocomplete, CircularProgress, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDebounce } from 'react-use'
import axiosInstant from '../../../api'
import { searchUser } from '../../../api/endpoints'


export function FieldUserAutoComplete( props ) {
  const { defaultValue } = props;
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [debounceSearchValue, setDebounceSearchValue] = useState('');
  const [, cancel] = useDebounce(
    () => {
      setDebounceSearchValue(inputValue)
    },
    500,
    [inputValue]
  )

  const loading = open && options.length === 0

  useEffect(() => {
    const sendSearchRequest = async () => {
      if (debounceSearchValue && debounceSearchValue !== defaultValue?.displayName) {
        try {
          // call API
          const response = await axiosInstant.get(searchUser(debounceSearchValue))
          const { data } = response
          setOptions(data.rows)
          setOpen(true)
        } catch (error) {
          console.error(error)
        }
      }
    }

    sendSearchRequest()
  }, [debounceSearchValue])

  const handleInputChange = (e, value ) => {
    setInputValue(value)
  }

  return (
    <Autocomplete
      sx={{ width: 300 }}
      open={open}
      options={options}
      onClose={ () => setOpen( false ) }
      onOpen={ () => setOpen( true ) }
      onInputChange={handleInputChange}
      getOptionLabel={(x) => x?.displayName}
      { ...props }
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            ...(props?.InputProps || {}),
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}
